import { formatRelativeTime } from '@/lib/misc/Utils'
import type { StatusFeedEntry, StatusLevel } from './types'
import { formatMaintWindow, getStatusLevelStyles } from './utils'

const StatusFeedEntryCard = ({ entry }: { entry: StatusFeedEntry }) => {
  const entryStyles = getStatusLevelStyles(entry.status as StatusLevel)
  const pillLabel =
    entry.maintPhase === 'upcoming'
      ? 'Planned'
      : entry.maintPhase === 'ongoing'
        ? 'In progress'
        : null

  const maintWindow = formatMaintWindow(entry.maintFrom, entry.maintTo)

  return (
    <div className="group relative flex gap-3 overflow-hidden px-3 py-2.5 transition-colors hover:bg-neutral-05/80">
      <div
        className={`absolute left-0 top-0 h-full w-[3px] rounded-r-sm ${entryStyles.dotClass}`}
      />

      <div className="min-w-0 flex-1 pl-1">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <p className="text-sm font-semibold text-neutral-60">{entry.title}</p>
          {pillLabel && (
            <span
              className={`inline-flex items-center rounded-full px-2 py-0.5 text-sm font-medium ring-1 ring-inset ${entryStyles.feedBadgeClass}`}
            >
              {pillLabel}
            </span>
          )}
        </div>

        {entry.message && (
          <p className="mt-0.5 text-sm leading-relaxed text-neutral-50">
            {entry.message}
          </p>
        )}

        <div>
          {maintWindow && (
            <span className="text-sm text-neutral-40">
              {maintWindow} &middot;{' '}
            </span>
          )}

          <span
            className="text-sm text-neutral-40"
            title={new Date(entry.date).toLocaleString(undefined, {
              hour: '2-digit',
              minute: '2-digit',
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })}
          >
            {formatRelativeTime(entry.date)}
          </span>
        </div>
      </div>
    </div>
  )
}

export default StatusFeedEntryCard
